import { currencies } from 'app/i18n/hardcoded_translations';
import { uniques, uniquesFromProp } from 'app/utils/array';

const getTournamentsLocation = (tournaments: SeriesTournamentWithRoster[]): string => {
  const locations = tournaments.map(tournament =>
    [tournament.country, tournament.region].filter(Boolean).join(', ')
  );
  const uniqueLocations = uniques(locations);
  if (uniqueLocations.length === 0) {
    return '-';
  }
  return uniqueLocations.join(', ');
};

const getBeginAndEndDates = (tournaments: SeriesTournamentWithRoster[]): [Date, Date] => {
  const beginDate = new Date(Math.min(...tournaments.map(t => new Date(t.begin_at).getTime())));
  const endDate = new Date(Math.max(...tournaments.map(t => new Date(t.end_at).getTime())));
  return [beginDate, endDate];
};

const getSeriesTeams = (tournaments: SeriesTournamentWithRoster[]): SeriesTeamWithRoster[] => {
  const teams = tournaments.flatMap(tournament => tournament.teams);
  return uniquesFromProp(teams, 'id');
};

const getPrizepool = (
  amount: SeriesOverviewBlockMatch['prizepool_amount'],
  currency: SeriesOverviewBlockMatch['prizepool_curency']
): string => {
  if (amount && currency) {
    const formatedCurrency = currencies[currency] ?? currency;
    return `${amount}${formatedCurrency}`;
  }

  return '-';
};

export { getTournamentsLocation, getBeginAndEndDates, getSeriesTeams, getPrizepool };
